import { render, staticRenderFns } from "./OnGoing.vue?vue&type=template&id=1e8f4874&"
import script from "./OnGoing.vue?vue&type=script&lang=js&"
export * from "./OnGoing.vue?vue&type=script&lang=js&"
import style0 from "./OnGoing.vue?vue&type=style&index=0&id=1e8f4874&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports